import React, { useState } from "react";
import { createLeadScoringConfig, updateLeadScoringConfig } from "../../services/leadscoring/api";
import { Typography, Divider, Box, Paper, makeStyles } from "@material-ui/core";
import CategorySection from "./CategorySection";
import FloatingSaveButton from "./FloatingSaveButton";
import RemarketingImpactSection from "./RemarketingImpactSection";
import ResetOnDispositionSection from "./ResetOnDispositionSection";
import CustomInput from "components/CustomInput/CustomInput.jsx";

const useStyles = makeStyles((theme) => ({
  scoreDisplay: {
    position: 'sticky',
    top: 0,
    backgroundColor: theme.palette.background.paper,
    zIndex: 1,
    display: 'flex',
  },
  scorePaper: {
    padding: '10px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.spacing(2),
    background: 'linear-gradient(135deg, #3f51b5, #2196f3)',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    minWidth: 200,
  },
  scoreValue: {
    color: '#ffffff',
    fontWeight: 'bold',
    fontSize: '1.5rem',
    textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
  },
  scoreLabel: {
    color: '#ffffff',
    marginRight: theme.spacing(1),
    fontSize: '1.2rem',
  }
}));


const LeadScoringForm = ({ user, config, onClose }) => {
  const classes = useStyles();
  console.log("config", config, user);
  const [leadScoring, setLeadScoring] = useState(config ? config : {
    name: "Default",
    defaultScore: 100,
    attributes: {
      disposition: { total: 25, rules: [] },
      entryBase: { total: 30, rules: [] },
      talktime: { total: 30, rules: [] },
      custom: { total: 15, rules: [] },
    },
    remarketingImpact: { whatsapp: 10, ivrCalls: 5, email: 5 },
    resetOnDisposition: [],
  });
  const maxScore = 100;


  // Handle name change
  const handleNameChange = (event) => {
    setLeadScoring((prev) => ({
      ...prev,
      name: event.target.value,
    }));
  };

  // Handle total score change for each category
  const handleTotalChange = (category, value) => {
    debugger;
    const updatedAttributes = { ...leadScoring.attributes };
    updatedAttributes[category].total = value;

    let otherScore = leadScoring.remarketingImpact.whatsapp + leadScoring.remarketingImpact.ivrCalls + leadScoring.remarketingImpact.email;
    let attributesScore = Object.values(updatedAttributes).reduce((total, attribute) => total + attribute.total, 0);
    let totalAttributesScore = attributesScore + otherScore;

    if (totalAttributesScore < value) {
      alert("Value cannot be greater than total");
      return;
    }
    if (value < 0) {
      alert("Value cannot be negative");
      return;
    }
    if (maxScore < totalAttributesScore) {
      alert("Value cannot be greater than max score");
      return;
    }
    if (value > maxScore) {
      alert("Value cannot be greater than max score");
      return;
    }

    setLeadScoring((prev) => ({
      ...prev,
      attributes: updatedAttributes,
      defaultScore: totalAttributesScore,
    }));
  };

  // Handle rule change
  const handleRuleChange = (category, index, event) => {
    const { name, value } = event.target;
    debugger;
    let total = leadScoring.attributes[category].total;
    if (value < 0) {
      alert("Value cannot be negative");
      return;
    }
    if (total < value) {
      alert("Value cannot be greater than total");
      return;
    }
    const updatedRules = [...leadScoring.attributes[category].rules];
    updatedRules[index][name] = value;

    setLeadScoring((prev) => ({
      ...prev,
      attributes: { ...prev.attributes, [category]: { ...prev.attributes[category], rules: updatedRules } },
    }));
  };

  // Add a new rule
  const handleAddRule = (category) => {
    let newRules = { field: "", operator: "==", value: "", score: 0 };
    if (category === "disposition") {
      newRules.field = "disposition";
    }
    if (category === "talktime") {
      newRules.field = "talktime";
      newRules.operator = ">";
    }
    if (category === "entryBase") {
      newRules.field = "updateStatus";
      newRules.operator = "==";
    }

    setLeadScoring((prev) => ({
      ...prev,
      attributes: {
        ...prev.attributes,
        [category]: { ...prev.attributes[category], rules: [...prev.attributes[category].rules, newRules] },
      }
    }));
  };

  // Remove a rule
  const handleRemoveRule = (category, index) => {
    const updatedRules = [...leadScoring.attributes[category].rules];
    updatedRules.splice(index, 1);

    setLeadScoring((prev) => ({
      ...prev,
      attributes: { ...prev.attributes, [category]: { ...prev.attributes[category], rules: updatedRules } },
    }));
  };

  // Handle remarketing impact change
  const handleRemarketingImpactChange = (field, value) => {
    let updatedRemarketingImpact = { ...leadScoring.remarketingImpact };
    updatedRemarketingImpact[field] = value;
    let otherScore = updatedRemarketingImpact.whatsapp + updatedRemarketingImpact.ivrCalls + updatedRemarketingImpact.email;
    let attributesScore = Object.values(leadScoring.attributes).reduce((total, attribute) => total + attribute.total, 0);
    let totalAttributesScore = attributesScore + otherScore;
    
    if (value < 0) {
      alert("Value cannot be negative");
      return;
    }
    if (totalAttributesScore < value) {
      alert("Value cannot be greater than total");
      return;
    }
    if (maxScore < totalAttributesScore) {
      alert("Value cannot be greater than max score");
      return;
    }
    if (value > maxScore) {
      alert("Value cannot be greater than max score");
      return;
    }
    setLeadScoring((prev) => ({
      ...prev,
      remarketingImpact: updatedRemarketingImpact,
      defaultScore: totalAttributesScore,
    }));
  };

  // Handle reset on disposition change
  const handleResetOnDispositionChange = (values) => {
    const totalAttributesScore = Object.values(leadScoring.attributes).reduce((total, attribute) => total + attribute.total, 0);
    setLeadScoring((prev) => ({
      ...prev,
      resetOnDisposition: values,
      defaultScore: totalAttributesScore,
    }));
  };

  // Submit lead scoring configuration
  const handleSubmit = async () => {
    const totalAttributesScore = Object.values(leadScoring.attributes).reduce((total, attribute) => total + attribute.total, 0);
    setLeadScoring((prev) => ({
      ...prev,
      defaultScore: totalAttributesScore,
    }));

    setTimeout(() => {
      if (config) {
        updateLeadScoringConfig(config._id, leadScoring);
      }
      else {
        createLeadScoringConfig(leadScoring);
      }
      alert("Lead Scoring Configuration Saved!");
      onClose();
    }, 2000);




  };

  return (
    <div>
      <Typography variant="h5" gutterBottom>
        Lead Scoring Configuration
      </Typography>
      <Divider style={{ marginBottom: 20 }} />

      <Box className={classes.scoreDisplay}>
        <Paper className={classes.scorePaper}>
          <Typography className={classes.scoreLabel}>Maximum Possible Score:</Typography>
          <Typography className={classes.scoreValue}>{leadScoring.defaultScore}</Typography>
        </Paper>
      </Box>

      {/* Name Field */}
      <CustomInput
        labelText="Configuration Name"
        id="name"
        formControlProps={{
          fullWidth: true,
        }}
        labelProps={{ shrink: true }}
        inputProps={{
          type: "text",
          defaultValue: leadScoring.name,
          onChange: handleNameChange,
        }}
      />

      {Object.keys(leadScoring.attributes).map((category) => (
        <CategorySection
          user={user}
          key={category} /* Using category name as key instead of index */
          category={category}
          total={leadScoring.attributes[category].total}
          rules={leadScoring.attributes[category].rules}
          onTotalChange={(value) => handleTotalChange(category, value)}
          onRuleChange={(index, event) => handleRuleChange(category, index, event)}
          onAddRule={() => handleAddRule(category)}
          onRemoveRule={(index) => handleRemoveRule(category, index)}
        />
      ))}

      <RemarketingImpactSection
        user={user}
        remarketingImpact={leadScoring.remarketingImpact}
        onChange={handleRemarketingImpactChange}
      />

      <ResetOnDispositionSection
        user={user}
        resetOnDisposition={leadScoring.resetOnDisposition}
        onChange={handleResetOnDispositionChange}
      />

      <FloatingSaveButton onClick={handleSubmit} />
    </div>
  );
};

export default LeadScoringForm;